import GenericSignalRService from "../GenericSignalRService";

class GlobalSignalRManager {
  constructor() {
    this.hubs = {};
  }

  getHub(hubName, hubUrl) {
    if (this.hubs[hubName]) {
      return this.hubs[hubName];
    }

    const newHub = new GenericSignalRService(hubUrl);
    newHub.startConnection();

    this.hubs[hubName] = newHub;
    return newHub;
  }

  async disposeHub(hubName) {
    if (this.hubs[hubName]) {
      await this.hubs[hubName].dispose();
      delete this.hubs[hubName];
    }
  }
}

const globalSignalRManager = new GlobalSignalRManager();
export default globalSignalRManager;